<template>
  <router-link
    class="BaseTag"
    :to="to">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'BaseTag',

  props: {
    to: { type: [String, Object], default: null },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.BaseTag {
  display: inline-block;
  padding-left: 4px;
  padding-right: 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  font-size: 11px;
  opacity: .5;
  border: 1px solid $dark;
  &:hover {
    opacity: 1;
  }
}
</style>
